import * as Icons from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WHY_CHOOSE_US } from "@/data/services";

export function WhyChooseUs() {
  return (
    <section data-testid="why-choose-us" className="py-20 sm:py-28 bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="label-eyebrow">Why Choose UNIRAD</p>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-medium tracking-tight text-brand-navy max-w-2xl text-balance">
            Diagnostics you can trust, care you can feel
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_CHOOSE_US.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Check;
            return (
              <Reveal key={item.title} delay={i * 0.07}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group h-full rounded-2xl border border-border bg-card p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand/5 hover:border-brand/30"
                >
                  <span className="grid place-items-center h-13 w-13 h-14 w-14 rounded-2xl bg-brand-soft text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                    <Icon className="h-6 w-6" strokeWidth={1.6} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-brand-navy">{item.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
